<template>
  <v-card v-if="billingItems && billingItems.length > 0">
    <v-card-title>
      Faturas Unificadas
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="billingItems"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td>
          {{
            props.item && props.item.consumer_unit
              ? props.item.consumer_unit.name
              : ""
          }}
        </td>
        <td>
          {{
            props.item &&
            props.item.consumer_unit &&
            props.item.consumer_unit.id
              ? props.item.consumer_unit.id
              : props.item.consumer_unit
          }}
        </td>
        <td>
          <v-icon color="grey">{{
            props.item.transaction && props.item.transaction.payment_method
              ? props.item.transaction.payment_method
              : "" | formatPaymentTypeIcon
          }}</v-icon>
        </td>
        <td>
          <v-btn
            round
            small
            v-if="props.item.status === 'error'"
            @click="openBillingDebug(props.item)"
            :color="props.item.status | formatStatusBillingColor"
            text-color="white"
            >{{ props.item.status | formatTransactionStatus }}</v-btn
          >
          <v-chip
            v-else
            :color="props.item.status | formatStatusBillingColor"
            text-color="white"
            small
            >{{ props.item.status | formatTransactionStatus }}</v-chip
          >
        </td>
        <!-- <td>
          <v-tooltip v-if="(isAdmin || isFinancial)" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" v-if="props.item.unique_billing" color="green darken-4">task_alt</v-icon>
              </template>
            <span>Conta Unificada.</span>
          </v-tooltip>
        </td> -->
        <td>
          <v-chip
            :color="
              formatBankingStatus(
                props.item.unique_billing_transaction
                  ? props.item.unique_billing_transaction.status
                  : '',
              ).color
            "
            text-color="white"
            small
          >
            {{
              props.item &&
              props.item.unique_billing_transaction &&
              props.item.unique_billing_transaction.status
                ? formatBankingStatus(
                    props.item.unique_billing_transaction.status,
                  ).label
                : "Agendar"
            }}</v-chip
          >
          <!-- <template v-slot:input>
              <v-autocomplete
                :items="bstatus"
                color="white"
                item-value="value"
                item-text="label"
                label="Ação"
            ></v-autocomplete>
          </template> -->
          <!-- <div v-if="props.item.banking_status">{{props.item.banking_status}}</div> -->
        </td>

        <!-- Valor Total da Fatura Enercred -->
        <td class="text-xs-right">
          R$ {{ props.item.total | formatCurrency }}
        </td>

        <!-- Data de Vencimento da Fatura Enercred -->
        <td>{{ props.item.due_date | formatarDate }}</td>

        <!-- Data que o Membro realizou o Pagamento -->
        <td>
          {{
            props.item.transaction && props.item.status === "paid"
              ? props.item.transaction.date_updated
              : "" | formatarDate
          }}
        </td>

        <!-- Data devido a Concessionaria -->
        <td class="text-xs-right">
          R$ {{ props.item.total_invoice | formatCurrency }}
        </td>

        <!-- Data de Vencimento da Concessionária -->
        <td
          :class="
            props.item.due_date_utility &&
            (!props.item.unique_billing_transaction ||
              (props.item.unique_billing_transaction &&
                props.item.unique_billing_transaction.status !== 'paid'))
              ? validUtilityOverdue(
                  props.item.status,
                  props.item.due_date_utility,
                )
              : 'text-xs-right'
          "
        >
          {{
            props.item.due_date_utility
              ? props.item.due_date_utility
              : "" | formatarDate
          }}
        </td>

        <!-- Data de Pagamento na Concessionaria -->
        <td class="text-xs-right">
          {{
            props.item.unique_billing_transaction
              ? props.item.unique_billing_transaction.paid_at
              : "" | formatarDate
          }}
        </td>

        <!-- Botoes de Ação -->
        <td class="text-xs-right">
          <v-tooltip
            v-if="isAdmin || isFinancial || isPartnerManagement"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                v-if="props.item.invoice_url"
                :href="props.item.invoice_url"
                target="_blank"
              >
                <v-icon color="red">plagiarism</v-icon>
              </v-btn>
            </template>
            <span>Ver demonstrativos.</span>
          </v-tooltip>
          <v-tooltip
            v-if="permissions.download_bill && props.item.bucket_path"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="downloadResumePdf(props.item.bucket_path)"
              >
                <v-icon color="blue">list_alt</v-icon>
              </v-btn>
            </template>
            <span>Ver conta da concessionária.</span>
          </v-tooltip>
          <v-tooltip
            v-if="
              (isAdmin || isFinancial || isPartnerManagement) &&
              props.item.bucket_path
            "
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                v-if="props.item.invoice_url"
                @click="goToCommunication(props.item.id)"
              >
                <v-icon color="purple">chat</v-icon>
              </v-btn>
            </template>
            <span>Ver comunicações enviadas.</span>
          </v-tooltip>
        </td>
        <td class="text-xs-right">
          <v-tooltip v-if="permissions.faturar" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                v-on="on"
                v-if="
                  props.item.status != 'paid' &&
                  props.item.status != 'succeeded' &&
                  props.item.status != 'paga' &&
                  props.item.status != 'free' &&
                  props.item.status != 'refunded' &&
                  props.item.status != 'chargedbillingack' &&
                  props.item.status != 'reprocessing' &&
                  props.item.status != 'in_queue' &&
                  props.item.status != 'negotiated' &&
                  props.item.status != 'parceled' &&
                  props.item.status != 'overdue' &&
                  props.item.status != 'waiting_payment'
                "
                @click.stop="faturar(props.item.id)"
                :loading="loading"
              >
                <v-icon color="red">cached</v-icon>
              </v-btn>
            </template>
            <span>Reprocessar o faturamento sem mudanças.</span>
          </v-tooltip>
          <v-tooltip v-if="permissions.resend_bill" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-2 pl-2"
                v-on="on"
                color="grey"
                :loading="loadingChange"
                @click.prevent="resendToClient(props.item.id)"
                >send</v-icon
              >
            </template>
            <span>Reenviar fatura.</span>
          </v-tooltip>
          <v-tooltip v-if="isAdmin || isFinancial" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-2 pl-2"
                v-on="on"
                color="grey"
                v-if="
                  props.item &&
                  props.item.transaction &&
                  (isAdmin || isFinancial)
                "
                @click.prevent="gotoTransactionHistory(props.item.id)"
                >visibility</v-icon
              >
            </template>
            <span>Detalhe da Fatura.</span>
          </v-tooltip>
          <!-- <v-icon color="grey" v-if="(isAdmin || isFinancial)" @click.prevent="goToCustomerCare(props.item.consumer_unit.id)">settings_accessibility</v-icon> -->
          <v-tooltip v-if="isAdmin || isFinancial" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="ml-2 pl-2"
                color="grey"
                v-if="isAdmin || isFinancial"
                @click.prevent="goToCustomerCare(props.item.consumer_unit.id)"
                >settings_accessibility</v-icon
              >
            </template>
            <span>Ir para tela de Atendimento.</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Sua busca "{{ search }}" não retornou resultados.
        </v-alert>
      </template>
    </v-data-table>
    <billing-debug />
    <detalhes-fatura />
    <v-dialog
      :lazy="true"
      v-model="dialog_communication"
      scrollable
      max-width="500px"
    >
      <v-card>
        <v-card-title>Comunicação</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <communication-billing v-if="billing_id" :billing_id="billing_id" />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            flat
            @click="dialog_communication = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-card>
</template>
<script>
import { eventBus } from "../../main";
import { mapState } from "vuex";
import BillingDebug from "./BillingDebug.vue";
import DetalhesFatura from "../faturaDetails/DetalhesFatura.vue";
import firestore from "../../firebase/firestore";
import { updateBilling, sendInvoice } from "../../services/billing";
import { firestorage } from "@/firebase/firestorage";
import CommunicationBilling from "../faturaDetails/CommunicationBilling.vue";
import { getPermission } from "../../services/permissions";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "consumer_unit.name",
        },
        {
          text: "Unidade consumidora",
          align: "left",
          value: "consumer_unit",
        },
        { text: "Mét. Pag.", value: "payment_method" },
        { text: "Status", value: "status" },
        // { text: 'Conta Unica', value: 'unique_billing' },
        { text: "Status Bancario", value: "banking_status" },
        { text: "Valor Total", align: "right", value: "total" },
        { text: "Data de Vcto", value: "total_energy" },
        { text: "Data de Pgto", value: "total_energy" },
        {
          text: "Valor Concessionária",
          align: "right",
          value: "total_utility",
        },
        { text: "Data de Venc. Conc.", value: "total_energy" },
        { text: "Data de Pgto Conc.", value: "total_energy" },
        { text: "Demonstrativo", value: "total_utility" },
        { text: "Ações", align: "right" },
      ],
      pag: {
        rowsPerPage: 20,
        // totalItems: 20
      },
      loading: false,
      loadingChange: false,
      color: "",
      snackMessage: "",
      snackbar: false,
      billing_id: null,
      dialog_communication: false,
      bstatus: [
        {
          label: "Agendar",
          value: "to_schedule",
          color: "orange",
        },
        {
          label: "Agendado",
          value: "scheduled",
          color: "blue",
        },
        {
          label: "Pago",
          value: "paid",
          color: "green",
        },
      ],
    };
  },
  computed: {
    ...mapState("uniquebilling", ["billingItems"]),
    ...mapState(["user", "permissions"]),
    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("admin") >= 0) {
        return true;
      }
      return false;
    },
    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("financial") >= 0) {
        return true;
      }
      return false;
    },
    isPartnerManagement() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("partner_management") >= 0) {
        return true;
      }
      return false;
    },
  },
  components: {
    BillingDebug: BillingDebug,
    DetalhesFatura,
    CommunicationBilling,
  },
  methods: {
    formatBankingStatus(status) {
      // console.log('s: ', status)
      if (!status || status === "") return this.bstatus[0];
      let f = (status = this.bstatus.filter((el) => {
        return el.value === status;
      }));
      console.log("f: ", f);
      return f[0];
    },
    openBillingDebug(billing) {
      eventBus.$emit("billingDebug", billing);
    },
    gotoTransactionHistory(transaction_id) {
      eventBus.$emit("billing_id", transaction_id);
      eventBus.$emit("right", true);
      // this.$router.replace(`/transaction/${transaction_id}`)
    },
    goToCustomerCare(consumer_unit) {
      this.$router.push({
        path: "/atendimento/?installation_number=" + consumer_unit,
      });
    },
    goToCommunication(id) {
      this.billing_id = id;
      this.dialog_communication = true;
    },
    async faturar(id) {
      try {
        this.loading = true;
        const permission = await getPermission("faturar", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.loading = false;
          return false;
        }
      } catch (err) {
        this.loading = false;
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      const newBillig = {
        updated_at: new Date(),
        status: "reprocessing",
        payment_type: "credit_card",
        card_id: this.reprocess_card_id || null,
      };
      firestore
        .collection("billing")
        .doc(id)
        .update(newBillig)
        .then(() => {
          this.loading = false;
          this.snack(
            "Sistema refaturando. Aguarde alguns segundos...",
            "success",
          );
          // vm.right = true;
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          // vm.right = true;
          this.snack("Erro ao iniciar o refaturamento!", "error");
        });
    },
    async resendToClient(billing_id) {
      try {
        this.loadingChange = true;
        const permission = await getPermission("resend_bill", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.loadingChange = false;
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }
      this.loadingChange = true;
      // console.log(this.resendBilling, this.resendBilling.id)
      await sendInvoice(billing_id, localStorage.getItem("token"));
      await updateBilling(billing_id, { resend_wpp: true })
        .then(() => {
          // this.resendDialog = false
          this.loadingChange = false;
          this.snack(
            "Reenvio de fatura iniciado. O reenvio acontece em até 1 minuto!",
            "green",
          );
        })
        .catch((err) => {
          // this.resendDialog = false
          this.loadingChange = false;
          this.snack(
            "Erro ao pedir reenvio de fatura. Tente novamente mais tarde. " +
              err,
            "red",
          );
          console.error(err);
        });
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    async downloadResumePdf(path) {
      try {
        const permission = await getPermission("download_bill", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          return false;
        }
      } catch (err) {
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }
      const resumeRef = firestorage.ref(path);
      resumeRef
        .getDownloadURL()
        .then((url) => {
          // `url` is the download URL
          // console.log(url);
          window.open(url, "_blank");
        })
        .catch((error) => {
          // Handle any errors
          switch (error.code) {
            case "storage/object-not-found":
              // File doesn't exist
              break;

            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;

            case "storage/canceled":
              // User canceled the upload
              break;

            case "storage/unknown":
              // Unknown error occurred, inspect the server response
              break;
            default:
              break;
          }
        });
    },
    validUtilityOverdue(status, utility_due_date) {
      console.log("status: ", status);
      console.log("utility_due_date: ", new Date(utility_due_date));
      console.log(
        "utility_due_date < new Date(): ",
        new Date(utility_due_date) < new Date(),
      );
      if ((status === "paid") & (new Date(utility_due_date) < new Date()))
        return "text-xs-right overdue";
      else return "text-xs-right";
    },
  },
};
</script>
<style scoped>
.overdue {
  color: red;
}
</style>
